"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.envReplace = void 0;
var env_replace_1 = require("./env-replace");
Object.defineProperty(exports, "envReplace", { enumerable: true, get: function () { return env_replace_1.envReplace; } });
//# sourceMappingURL=index.js.map